import { z } from "zod";
import { id } from "../schemas/common";
import { labelCodeInput } from "./codes";

/** How many blank labels go into the basket at once (ADR 0018 › Label basket). */
export const MAX_BLANK_LABELS = 500;

/** How many parts go into the basket at once: a parts list's selection. */
export const MAX_BASKET_PARTS = 500;

export const labelInput = z.object({ code: labelCodeInput });

export const blankLabelsInput = z.object({
  count: z
    .int({ error: "validation.number" })
    .positive({ error: "validation.positive" })
    .max(MAX_BLANK_LABELS, { error: "validation.tooLarge" }),
});

/** A label onto a part: a blank one assigned, or one moved to another part. */
export const labelPartInput = z.object({ code: labelCodeInput, partId: id });

export const basketPartsInput = z.object({
  partIds: z.array(id).min(1).max(MAX_BASKET_PARTS),
  /** A new code even for parts that have a label already, instead of reprinting it. */
  newLabel: z.boolean().default(false),
});
